var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"contact-modal"},[_c('div',{staticClass:"contact-modal-content"},[_vm._v("如需配置视频")]),_c('div',{staticClass:"contact-modal-content"},[_vm._v("请拨打400-789-0789")]),_c('div',{staticClass:"contact-modal-content"},[_vm._v("联系海纳工作人员")])])
}]

export { render, staticRenderFns }